import { Box } from "@mui/material";

const LoadingFilter = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "-5px",
        left: 0,
        right: 0,
        bottom: "-5px",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        borderRadius: "8px",
        zIndex: 9999,
      }}
    ></Box>
  );
};

export default LoadingFilter;
